<template>
  <div id="page">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />

    <div id="title-one">二、综合评价情况</div>
    <div id="title-two"  v-if="this.isMemberEnterpriseTeam === false">
      {{ this.model.departmentName }}
    </div>
    <div id="title-two">2.1 个人基本信息</div>

    <div style="margin-left: 60px">
      <table
        border="1"
        width="674"
        class="table-info3"
        style="margin-top: 10px"
      >
        <tr border="1" width="674" height="50px">
          <td colspan="3">
            <span class="et3"
              ><b style="color: #9e9e9e;font-we"
                >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
                &nbsp;&nbsp;&nbsp;</b
              ><b>{{ this.model.name }}</b></span
            >
          </td>
        </tr>
        <tr border="1" width="674" height="50px">
          <td colspan="3">
            <span class="et3">
              <b style="color: #9e9e9e">所属企业&nbsp;&nbsp;&nbsp;</b
              >
              <b v-if="this.isMemberEnterpriseTeam === false">中国建材集团有限公司总部</b>
              <b v-if="this.isMemberEnterpriseTeam === true">{{this.company || '中国建材集团有限公司总部'}}</b>
            </span>
          </td>
        </tr>
        <tr border="1" width="674">
          <td width="220" class="et3">
            <b style="color: #9e9e9e">性别</b><br /><b>{{
              this.sex || " "
            }}</b>
          </td>
          <td width="220" class="et3">
            <b style="color: #9e9e9e">出生年月</b><br />
            <b>{{ this.birthday || " " }}</b>
          </td>
          <td width="244" class="et3">
            <b style="color: #9e9e9e">学历学位</b><br />
            <b>{{ this.degree || " " }}</b>
          </td>
        </tr>

        <tr border="1" width="674">
          <td width="220" class="et3" v-if="this.departmentName && this.isMemberEnterpriseTeam === false" >
            <b style="color: #9e9e9e">部门</b><br />
            <b>{{ this.departmentName || " " }}</b>
          </td>
          <td width="220" class="et3" v-if="this.departmentName==='' && this.level==='' " colspan="3">
            <b style="color: #9e9e9e">现任职务</b><br /><b>{{
              this.job || " "
            }}</b>
          </td>
             <td width="220" class="et3"  v-if="this.departmentName!=='' && this.level!==''" >
            <b style="color: #9e9e9e">现任职务</b><br /><b>{{
              this.job || " "
            }}</b>
          </td>

          <td width="224" class="et3" v-if="this.level && this.isMemberEnterpriseTeam === true" colspan="2" >
            <b style="color: #9e9e9e">层级</b><br /><b>{{
              this.level || " "
            }}</b>
          </td>
          <td width="224" class="et3" v-if="this.level && this.isMemberEnterpriseTeam === false ">
            <b style="color: #9e9e9e">层级</b><br /><b>{{
              this.level || " "
            }}</b>
          </td>
        </tr>
      </table>
    </div>
    <div id="title-two">2.2 360胜任力评价说明</div>
    <!-- <div class="note-info">数据及信息来源：中国建材集团人力资源部</div> -->
    <div style="margin: 18px 60px 0 60px; line-height: 30px; text-indent: 30px">
      <!-- FIXME 只有一个级别 -->
      整体而言，<span v-if="this.minScore">
      {{ this.model.name }}的
      <span style="color: #ee2d46; font-weight: bold">{{ this.maxName }}</span
      >评价分数最高
      <span style="color: #ee2d46; font-weight: bold"
        >({{ this.maxScore }}分)</span
      >，
      <span style="color: #ee2d46; font-weight: bold">{{
        this.middleName
      }}</span>

      <!---------------- 有上级的分数 --------------------------->
      <span v-if="this.avg.length > 2">
        <span style="color: #ee2d46; font-weight: bold"
          >({{ this.middleScore }}分)</span
        >，
      </span>

      <span v-if="this.avg.length > 3">
        <span style="color: #ee2d46; font-weight: bold">{{
          this.middle2Name
        }}</span>

        <span style="color: #ee2d46; font-weight: bold"
          >({{ this.middle2Score }}分)</span
        >，
      </span>
      <!---------------- ---------------------------->
      <span style="color: #ee2d46; font-weight: bold">{{ this.minName }}</span
      >评分最低<span style="color: #ee2d46; font-weight: bold"
        >({{ this.minScore }}分)</span
      >。
      </span>


      <span v-if="this.score1 !== 0"
        >{{ this.model.name }}的<span style="color: #ee2d46; font-weight: bold"
          >自评</span
        >分数<span style="color: #ee2d46; font-weight: bold"
          >（{{ this.score1 }}分）</span
        >{{ this.compareResult }}于<span
          style="color: #ee2d46; font-weight: bold"
          >他评</span
        >分数<span style="color: #ee2d46; font-weight: bold"
          >（{{ this.TaScore }}分）</span
        >。</span
      >

      <span v-if="this.score1 === 0"
        >{{ this.model.name }}没有进行自评，无<span
          style="color: #ee2d46; font-weight: bold"
          >自评</span
        >分数，<span style="color: #ee2d46; font-weight: bold">他评</span
        >分数为<span style="color: #ee2d46; font-weight: bold"
          >{{ this.TaScore }}分</span
        >。</span
      >
        <span v-if="results.length!==0">
      其中：
    </span>
    </div>
  


    <div
      v-for="(item, index) in this.results"
      :key="'new_' + index"
      style="margin: 4px 60px 0 60px; line-height: 30px; text-indent: 30px"
    >
      在{{ item.level }}评分中， {{ item.name }}在
      <span
        style="font-weight: bold; color: #f67020"
        v-if="item.level == '自评'"
      >
        {{ item.good1.toString().replace(/,/g, "，") }}
      </span>
      <span
        style="font-weight: bold; color: #2abcb9"
        v-if="item.level == '他评'"
      >
        {{ item.good1.toString().replace(/,/g, "，") }}
      </span>

      指标上得分最高，而
      <span
        style="font-weight: bold; color: #f67020"
        v-if="item.level == '自评'"
      >
        {{ item.bad1.toString().replace(/,/g, "，") || '无'}}
      </span>
      <span
        style="font-weight: bold; color: #2abcb9"
        v-if="item.level == '他评'"
      >
        {{ item.bad1.toString().replace(/,/g, "，") || '无'}}
      </span>
      得分最低。
    </div>
    <div id="footer">
      <span id="footer-red"
        >2</span
      >
    </div>
  </div>
</template>

<script>
import capability1 from "@/components/dataView/echarts/four/capability1.vue";
export default {
  props: ["model", "employeeInfos", "evaluate", "avg", "result", "TaScore","isMemberEnterpriseTeam"],
  components: { capability1 },
  data() {
    return {
      sex: "",
      birthday: "",
      degree: "",
      departmentName: "",
      company:"",
      job: "",
      level: "",
      maxName: "",
      maxScore: "",
      middleName: "",
      middleScore: "",
      middle2Name: "",
      middle2Score: "",

      minName: "",
      minScore: "",

      score1: 0,
      compareResult: "",
      titleLine: [],
      title1: "",
      good1: [],
      bad1: [],
      title2: "",
      good2: [],
      bad2: [],
      title3: "",
      good3: [],
      bad3: [],
      title4: "",
      good4: [],
      bad4: [],
      name: "",
      results: [],
      len: 0,
      images: {
        top: require("@/views/CNBM/images/top.png"),
      },
    };
  },
  mounted() {
    if (this.avg.length != 0) {
      this.loadData();
    }
  },
  watch: {
    employeeInfos(val) {
      this.loadData();
    },
    evaluate(val) {
      if (val) {
        this.loadData();
        this.handleResult();
      }
    },
  },
  methods: {
    loadData() {
      this.employeeInfos.map((item) => {
        if (item.key == "性别") {
          this.sex = item.value;
        }
        if (item.key == "出生年月") {
          this.birthday = item.value;
        }
        if (item.key == "学历学位") {
          this.degree = item.value;
        }
        if (item.key == "部门") {
          this.departmentName = item.value;
        }
        if (item.key == "现任职务") {
          this.job = item.value;
        }
        if (item.key == "层级") {
          this.level = item.value;
        }
        if(item.key === '所属企业'){
          this.company = item.value;
        }
      });
      this.name = this.model.name;
      let len = this.avg.length;
      this.avg.map((item) => {
        if (item.level == "自评") {
          this.score1 = item.score;
        }
      });
      if (parseFloat(this.score1) > parseFloat(this.TaScore)) {
        this.compareResult = "高";
      } else if (parseFloat(this.score1) == parseFloat(this.TaScore)) {
        this.compareResult = "等";
      } else {
        this.compareResult = "低";
      }
      if(this.avg.length === 3){
        this.maxScore = this.avg[0].score;
        this.maxName = this.avg[0].level;
        this.middleScore = this.avg[1].score;
        this.middleName = this.avg[1].level;
        this.minName = this.avg[2].level;
        this.minScore = this.avg[2].score;
      }

      //  if(this.avg.length === 2){
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      //   this.minName = this.avg[1].level;
      //   this.minScore = this.avg[1].score;
      // }

      //   if(this.avg.length === 1){
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      // }

      // if (this.avg.length > 3) {
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      //   this.middleScore = this.avg[1].score;
      //   this.middleName = this.avg[1].level;
      //   this.middle2Name = this.avg[2].level;
      //   this.middle2Score = this.avg[2].score;
      //   this.minName = this.avg[3].level;
      //   this.minScore = this.avg[3].score;
      // } else {
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;

      //   if(this.avg.length > 1)
      //   this.middleScore = this.avg[0].score;
      //   this.middleName = this.avg[0].level;

      //   if (this.avg.length > 2) {
      //     this.minName = this.avg[2].level;
      //     this.minScore = this.avg[2].score;
      //   }
      // }
    },
    handleResult() {
      this.result.map((item) => {
        if (item.level === "自评") {
          this.results.push(item);
        } else if (item.level === "他评") {
          this.results.push(item);
        } else {
          return;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
  .title {
    padding-top: 30px;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    font-weight: bold;
    font-size: 25px;
  }
  .title-two {
    font-size: 22px;
    font-weight: bold;
    margin: 10px 60px 0 60px;
  }
  .content-info {
    margin: 10px 60px 0 60px;
    line-height: 30px;
    text-indent: 30px;
  }
  .table-info3 {
    border: 2px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
    font-size: 17px;
    width: 674px;
  }
  .table-info {
    border: 2px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
  }
  .table-info1 {
    border: 1px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
    border-left: none;
  }
  .note-info {
    text-align: right;
    font-size: 10px;
    margin-right: 70px;
    color: #6e7079;
  }
  .et2 {
    vertical-align: middle;
    font-weight: bold;
    text-align: center;
    padding: 3px;
  }
  .et3 {
    vertical-align: left;
    // font-weight: bold;
    text-align: left;
    padding: 10px;
  }
  #footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 60px; /*脚部的高度*/
    text-align: center;
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/views/CCCST/pages/page-two.vue